function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  stroke: "#d3d3d3",
  strokeMiterlimit: 10,
  fill: "#0079be"
},
/*#__PURE__*/
React.createElement("rect", {
  width: 30,
  height: 20,
  rx: 2,
  stroke: "none"
}),
/*#__PURE__*/
React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 29,
  height: 19,
  rx: 1.5,
  fill: "none"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  d: "M22.177 9.9a6.118 6.118 0 00-6.258-6.05H13.1A5.91 5.91 0 007.064 9.9a6 6 0 006.036 5.945h2.816A6.226 6.226 0 0022.177 9.9z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.121 4.354A5.491 5.491 0 1018.6 9.845a5.485 5.485 0 00-5.479-5.491z",
  fill: "#0079be"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  d: "M9.658 9.835a3.486 3.486 0 012.229-3.248v6.5a3.484 3.484 0 01-2.229-3.252zm4.714 3.249v-6.5a3.481 3.481 0 010 6.5z"
});

var SvgCreditCardDinersClub = function SvgCreditCardDinersClub(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 30,
      height: 20,
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, ">", _ref2, _ref3, _ref4, _ref5)
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgCreditCardDinersClub, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/CreditCard_DinersClub.0f56e1ef.svg";
export { ForwardRef as ReactComponent };